// initial state
const state = () => ({
    price: 27,
    stripeApplicationFee: 10,
    primaryColor: "#00af74",
    colorPresets: [
        "#00af74",
        "#000000",
        "#FFFFFF",
        "#f72585",
        "#b5179e",
        "#7209B7",
        "#560BAD",
        "#480CA8",
        "#3A0CA3",
        "#3F37C9",
        "#4361EE",
        "#4895EF",
        "#4CC9F0",
        "#390099",
        "#9E0059",
        "#FF0054",
        "#FF5400",
        "#FFBD00",
        "#8AA8A1",
        "#CBCBD4",
        "#D1B490",
        "#CCB7AE",
        "#D6CFCB",
        "#0CCE6B",
        "#363537",
        "#cb997e",
        "#eddcd2",
        "#fff1e6",
        "#f0efeb",
        "#fbf8cc",
        "#fde4cf",
        "#ffcfd2",
        "#f1c0e8",
        "#cfbaf0",
        "#a3c4f3",
        "#90dbf4",
        "#8eecf5",
        "#98f5e1",
        "#b9fbc0",
        "#03071e",
        "#370617",
        "#6a040f",
        "#9d0208",
        "#d00000",
        "#dc2f02",
        "#e85d04",
        "#f48c06",
        "#faa307",
        "#ffba08",
        "#007f5f",
        "#2b9348",
        "#55a630",
        "#80b918",
        "#aacc00",
        "#bfd200",
        "#d4d700",
        "#dddf00",
        "#eeef20",
        "#ffff3f",
        "#03045e",
        "#0077b6",
        "#00b4d8",
        "#90e0ef",
        "#caf0f8",
        "#b98b73",
        "#ddbea9",
        "#ffe8d6",
        "#d4c7b0",
        "#b7b7a4",
        "#a5a58d",
        "#6b705c",
        "#3f4238",
        "fffffc",
        "edf2fb",
        "d8f3dc",
        "caf0f8",
        "f8edeb",
    ],
});

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
